import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('App crashed:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <p>Something went wrong loading this page.</p>
          <p>If you just made a payment, please check your email for your tickets before trying again.</p>
          <a href="/">Return to home</a>
        </div>
      );
    }
    return this.props.children;
  }
}